import React from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import "../styles/about.scss";

const metricsData = [
  { value: 250, label: "Projects Completed" },
  { value: 150, label: "Satisfied Clients" },
  { value: 50, label: "Awards Won" },
  { value: 10, label: "Years of Experience" },
];

function Metrics() {
  const { ref, inView } = useInView({
    triggerOnce: true,  // only animate once
    threshold: 0.3,     // 30% of the section visible
  });

  return (
    <section className="metrics" ref={ref}>
      <div className="metrics-content container">
        {metricsData.map((metric, idx) => (
          <div className="metric-box" key={idx}>
            <h2>
              {inView ? <CountUp end={metric.value} duration={5} /> : 0}+
            </h2>
            <p>{metric.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Metrics;
